module.exports = __webpack_public_path__ + "img/LT112043658.634d0ad5.png";